import React, { useEffect } from 'react'
import { Box, Typography, Container, Paper, Stack, CircularProgress } from '@mui/material'
import LogoutIcon from '@mui/icons-material/Logout'
import authService from '../services/authService'

export default function Logout() {
  useEffect(() => {
    const timer = setTimeout(() => {
      authService.logout()
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center', bgcolor: 'background.paper' }}>
          <LogoutIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>Sesión Cerrada</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Su sesión ha sido cerrada correctamente. Será redirigido a la pantalla de inicio de sesión...
          </Typography>
          <Stack direction="row" spacing={1} justifyContent="center" sx={{ mt: 3 }}>
            <CircularProgress size={24} />
          </Stack>
        </Paper>
      </Container>
    </Box>
  )
}
